'use strict';

import Collection from './collection.js';
import ChangeLog from 'newModels/change-log.js';

export default class ChangeLogs extends Collection {
    url() {
        if (this.company) {
            return this.company.url() + '/changeLogs';
        }

        return '/ChangeLogs';
    }

    initialize(models, {company = null}) {
        this.model = ChangeLog;
        this.company = company;
        super.initialize(...arguments);
        if (!this.options.sortKey) {
            this.options.sortKey = 'createdAt';
        }
        if (!this.options.sortOrder) {
            this.options.sortOrder = 'descending';
        }
        return this;
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/change-logs.js